export const cognitoConfig = {
  region: 'ca-central-1',
  userPoolId: 'ca-central-1_VWFHgLyOI',
  clientId: '59k3j90mrs4jip9frtntqbc7kj',
  cognitoDomain: 'https://public-privacy-education.auth.ca-central-1.amazoncognito.com',
  scopes: 'email openid profile',
};

function getRedirectUri(): string {
  return window.location.hostname === 'localhost'
    ? 'http://localhost:3000/callback'
    : 'https://public.privacy.education/callback';
}

export function getLoginURL(): string {
  const { cognitoDomain, clientId, scopes } = cognitoConfig;
  return `${cognitoDomain}/login?client_id=${clientId}&response_type=token&scope=${encodeURIComponent(scopes)}&redirect_uri=${encodeURIComponent(getRedirectUri())}`;
}

export function getSignUpURL(): string {
  const { cognitoDomain, clientId, scopes } = cognitoConfig;
  return `${cognitoDomain}/signup?client_id=${clientId}&response_type=token&scope=${encodeURIComponent(scopes)}&redirect_uri=${encodeURIComponent(getRedirectUri())}`;
}

export function getLogoutURL(): string {
  const { cognitoDomain, clientId } = cognitoConfig;
  const logoutUri = window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : 'https://public.privacy.education';
  return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}

export function parseJWT(token: string): any {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function getStoredToken(): string | null {
  return localStorage.getItem('pe_pub_id_token');
}

export function isTokenValid(token: string): boolean {
  const payload = parseJWT(token);
  return payload && payload.exp * 1000 > Date.now();
}

export function storeSession(idToken: string): void {
  const payload = parseJWT(idToken);
  if (!payload) return;
  localStorage.setItem('pe_pub_id_token', idToken);
  localStorage.setItem('pe_pub_user_email', payload.email || '');
  localStorage.setItem('pe_pub_user_sub', payload.sub || '');
  const name = payload.name || payload.email || '';
  localStorage.setItem('pe_pub_user_name', name);
}

export function clearSession(): void {
  localStorage.removeItem('pe_pub_id_token');
  localStorage.removeItem('pe_pub_user_email');
  localStorage.removeItem('pe_pub_user_sub');
  localStorage.removeItem('pe_pub_user_name');
}

export function getUserEmail(): string {
  return localStorage.getItem('pe_pub_user_email') || '';
}

export function getUserName(): string {
  return localStorage.getItem('pe_pub_user_name') || '';
}

export function getUserSub(): string {
  return localStorage.getItem('pe_pub_user_sub') || '';
}

export function isAuthenticated(): boolean {
  const token = getStoredToken();
  return !!token && isTokenValid(token);
}

export function isOrgAdmin(): boolean {
  const token = getStoredToken();
  if (!token) return false;
  const payload = parseJWT(token);
  if (!payload) return false;
  const groups: string[] = payload['cognito:groups'] || [];
  return groups.includes('org_admin');
}

export function isSuperAdmin(): boolean {
  const token = getStoredToken();
  if (!token) return false;
  const payload = parseJWT(token);
  if (!payload) return false;
  const groups: string[] = payload['cognito:groups'] || [];
  return groups.includes('super_admin');
}
